var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video"},[_c('v-row',[_c('v-col',[_c('LazyYoutube',{ref:"lazyVideo",attrs:{"src":'https://www.youtube.com/embed/'+_vm.video,"autoplay":true}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }